import React, { useState, FC, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControlLabel,
} from "@material-ui/core";
import {colorBorder, colorInputBorder} from "../../../Constants/theme";
import {PetGeneralInfo} from "../../index";

const useStyles = makeStyles({
    dialog: {
        padding: "20px",
        maxWidth: 750
    },
    dialogTitle: {
        fontSize: "24px",
        fontWeight: "bold"
    },
    dialogMessage: {
        padding: "10px 0",
        fontSize: "19px",
        letterSpacing: "-0.078px"
    },
    button: {
        padding: "12px 32px",
        color: colorInputBorder,
        border: `1px solid ${colorInputBorder}`
    }
});
// eslint-disable-next-line react/prop-types
const AnimalProfile = ({isOpen, animal=null, setModalProfile = null})  => {
    const classes = useStyles();
    const [isOnBoarding, setIsOnBoarding] = useState(false);
    const handleClose = () => {
        setModalProfile(false);
    };
    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            scroll="body"
            disableEnforceFocus
            classes={{paper: classes.dialog}}>
            <DialogTitle color="primary" classes={{root: classes.dialogTitle}}>
            </DialogTitle>
            <DialogContent>
                <PetGeneralInfo isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding} disabled={true} id={{petId:animal?.id}}/>
            </DialogContent>
            <DialogActions>
                <Button autoFocus variant="contained" onClick={handleClose} classes={{root: classes.button}}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AnimalProfile;
